import { render } from "./Source.vue?vue&type=template&id=4a505fa9"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/aft/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__